<template>
  <div class="grid gap-x-8 sm:grid-cols-1 md:grid-cols-1 mt-4">
    <div class="panel">
      <div class="panel-body">
        <div class="flex flex-row justify-center">
          <img src="@/assets/crop_field_analysis.png" alt="Análisis de campo" />
        </div>
        <div class="flex flex-row justify-center mt-6">
          <div class="w-3/5">
            <div class="panel-body">
              <h3 class="font-medium text-lg">Recomendaciones</h3>
              <p>
                El análisis de NDVI es un indicador relacionado a la vigorosidad
                del cultivo analizado, que nos presenta un rango espectral de -1
                (rojo) a 1 (verde), en el cual las zonas rojas indican menor
                frondosidad del campo y las zonas verdes con mayor frondosidad.
                <br />
                Por lo cual, se recomienda analizar los terrenos con indicador
                rojo para tomar decisiones respecto a nutrición, riego o
                aplicación para estos cultivos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProdReportingProcessShowReportsCropFieldAnalysis",
  data() {
    return {};
  },
  props: {
    producer_id: { required: true },
    agro_exporter_process_id: { required: true }
  },
  created() {},
  computed: {},
  methods: {},
  watch: {}
};
</script>
